// Axios already unwraps HTTP response.data; a few older API routes wrap once more.
export function recordList(response, key) {
  const body = response?.data?.data ?? response?.data ?? response;
  const rows = Array.isArray(body) ? body : body?.[key];
  return {
    rows: Array.isArray(rows) ? rows : [],
    total: body?.pagination?.total ?? body?.total ?? response?.pagination?.total ?? response?.total ?? (Array.isArray(rows) ? rows.length : 0),
  };
}
export const money = value => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 2 }).format(Number(value) || 0);
export function csvCell(value) {
  let text = value == null ? '' : String(value);
  if (/^[\s]*[=+@-]/.test(text) || /^[\t\r\n]/.test(text)) text = `'${text}`;
  return `"${text.replace(/"/g, '""')}"`;
}
export function safeDocumentUrl(value) {
  try {
    const url = new URL(value);
    return ['https:', 'http:'].includes(url.protocol) ? url.href : undefined;
  } catch { return undefined; }
}

// Care operations use India time, independent of the viewing device's timezone.
export function careDate(value, includeTime = false) {
  const date = value ? new Date(value) : null;
  if (!date || Number.isNaN(date.getTime())) return '—';
  const label = new Intl.DateTimeFormat('en-IN', {
    timeZone: 'Asia/Kolkata', day: '2-digit', month: 'short', year: 'numeric',
    ...(includeTime ? {hour: '2-digit', minute: '2-digit', hour12: true} : {}),
  }).format(date);
  return includeTime ? `${label} IST` : label;
}

export function ageLabel(patient) {
  let age = patient?.age;
  if (patient?.dateOfBirth) {
    const birth = new Date(patient.dateOfBirth), now = new Date(Date.now() + 19800000);
    age = now.getUTCFullYear() - birth.getUTCFullYear() - Number(now.getUTCMonth() < birth.getUTCMonth() || (now.getUTCMonth() === birth.getUTCMonth() && now.getUTCDate() < birth.getUTCDate()));
  }
  return Number.isInteger(age) && age >= 0 && age <= 130 ? `${age} years` : 'Not provided';
}
